import { motion } from "framer-motion";
import { SignInChooser } from "@/components/SignInChooser";

export default function Hero() {
  return (
    <section id="top" className="relative">
      <div className="bg-gradient-to-b from-navy to-navydeep">
        <div className="mx-auto max-w-[1160px] px-6 pt-36 pb-24 md:pt-44 md:pb-32">
          <motion.span
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            data-testid="hero-chip"
            className="inline-block text-[11px] font-bold uppercase tracking-[0.25em] text-white/80 border border-white/25 rounded-full px-4 py-2"
          >
            Patent pending · by WorkSafeAgent
          </motion.span>
          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="mt-8 text-[36px] sm:text-6xl lg:text-7xl font-extrabold leading-[1.05] text-white max-w-4xl"
          >
            See the hazard <span className="text-safety">before</span> it becomes the incident.
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.35 }}
            data-testid="hero-sub"
            className="mt-6 max-w-2xl text-base md:text-lg text-white/75 leading-relaxed"
          >
            WSafe AI turns the cameras you already have into a prevention system, routes every hazard to the
            person who can fix it, and keeps your records inspection-ready.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="mt-10 flex flex-wrap items-center gap-4"
          >
            <a
              href="/contact?topic=pilot"
              data-testid="hero-cta-pilot"
              className="rounded-lg bg-safety text-white font-bold px-7 py-3.5 hover:bg-[#d97c12] transition-colors"
            >
              Book a pilot
            </a>
            <SignInChooser
              testidPrefix="hero-signin"
              buttonClass="rounded-lg border-2 border-white/40 text-white font-bold px-7 py-3.5 inline-flex items-center gap-2 hover:border-white hover:bg-white/5 transition-colors"
            />
          </motion.div>
        </div>
      </div>
      <div className="hazard-yellow" aria-hidden="true" />
    </section>
  );
}
